'use client';

import React, { useEffect, useState } from 'react';
import { LocaleProvider, type LocaleLanguage } from '@/lib/locale-context';
import { Header } from '@/components/header/Header';
import { Footer } from '@/components/footer/Footer';
import { fetchHeaderData } from '@/api/header';
import { getFooterLinks } from '@/components/footer/getFooterLinks';
// Client-side dictionary loader
const loadDictionary = async (locale: LocaleLanguage) => {
  try {
    const dict = await import(`@/dictionaries/${locale}.json`);
    return dict.default;
  } catch (error) {
    console.error('Failed to load dictionary:', error);
    return null;
  }
};

interface NotFoundWrapperProps {
  locale: LocaleLanguage;
  children: React.ReactNode;
}

export function NotFoundWrapper({ locale, children }: NotFoundWrapperProps) {
  const [headerData, setHeaderData] = useState<any>([]);
  const [footerData, setFooterData] = useState<any>(null);
  const [dict, setDict] = useState<any>(null);

  useEffect(() => {
    async function loadData() {
      try {
        const [headerResponse, dictionary] = await Promise.all([
          fetchHeaderData(locale),
          loadDictionary(locale),
        ]);

        setHeaderData(headerResponse);
        setDict(dictionary);
        setFooterData(getFooterLinks(dictionary));
      } catch (error) {
        console.error('Failed to load data for 404 page:', error);
      }
    }

    loadData();
  }, [locale]);

  if (!dict || !footerData) {
    // Show loading state or fallback
    return <div>Loading...</div>;
  }

  return (
    <LocaleProvider locale={locale} dict={dict}>
      <Header headerData={headerData} />
      {children}
      <Footer {...footerData} />
    </LocaleProvider>
  );
}
